import React, { useEffect } from "react";
//import { loadPreferencesAsync, selectPreferences } from "./state/chatSlice";
import { useDispatch } from "react-redux";

import FullPageLoader from './components/system-components/loaders/FullPageLoader';
import { useNavigate } from "react-router-dom";

export default function AppRedirect() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    //const preferences = useSelector(selectPreferences);

    useEffect(() => {
        navigate('/home');
    }, [dispatch, navigate]);
    return <FullPageLoader />;
}
